import React, { createContext, useContext, useState, useEffect } from "react";
import { TRANSLATIONS, LANGUAGES } from "@/lib/i18n";

const LanguageContext = createContext({
  lang: "sq",
  setLang: () => {},
  t: TRANSLATIONS.sq,
  languages: LANGUAGES,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("ff_lang");
    if (saved && ["sq", "it", "en"].includes(saved)) {
      return saved;
    }
    return "sq";
  });

  const setLang = (newLang) => {
    if (["sq", "it", "en"].includes(newLang)) {
      setLangState(newLang);
      localStorage.setItem("ff_lang", newLang);
      document.documentElement.lang = newLang;
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = TRANSLATIONS[lang] || TRANSLATIONS.sq;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
